import get from 'lodash/get';
import forEach from 'lodash/forEach';
import pickBy from 'lodash/pickBy';

export const buildFiltersParamsString = filters => {
  const res = [];

  forEach(filters, (value, key) => {
    res.push(`filters[${key}]=${encodeURI(value)}`);
  });

  return res.join('&');
};

// Builds a string query only with page size: page[size]=20
export const buildPageParamStringForSection = (sections, key) => `page[size]=${get(sections, key)}`;

// Builds a string query with all sections sizes: page[organic][size]=20&page[premium][size]=8
export const buildPageParamStringForSections = sections => {
  const res = [];
  forEach(pickBy(sections, value => value > 0), (value, key) =>
    res.push(`page[${key}][size]=${value}`)
  );

  return res.join('&');
};

export const buildQueryParamsString = query =>
  Object.keys(query)
    .map(key => {
      if (query[key] === '' || query[key] === null || query[key] === undefined) {
        return null;
      }

      return `${key}=${encodeURIComponent(query[key])}`;
    })
    .filter(value => value)
    .join('&');

export const applyPathParamsToUrl = (url, params) => {
  let result = url;
  if (params) {
    Object.keys(params).forEach(key => {
      result = result.replace(`{${key}}`, encodeURI(params[key]));
    });
  }

  return result;
};

const buildFeaturesHomes = (location, verticalProperties) => ({
  cityArea: location.cityArea,
  city: location.city,
  region: location.region,
  typeId: verticalProperties.typeId,
  rooms: verticalProperties.rooms,
  floorArea: verticalProperties.floorArea,
});

const buildFeaturesCars = verticalProperties => ({
  make: verticalProperties.make,
  model: verticalProperties.model,
  mileage: verticalProperties.mileage,
  year: verticalProperties.year,
});

// Require what, where and page parameters from lost searchParameters after redirect redirection (href feature)
const buildFeaturesJobs = verticalProperties => ({
  categoryId: verticalProperties.category,
  what: verticalProperties.what,
  where: verticalProperties.where,
});

const buildFeaturesProducts = verticalProperties => ({
  categoryId: verticalProperties.categoryId || 0,
});

const buildFeatures = ({ verticalName, verticalProperties }) => {
  let features;
  const location = verticalProperties.location;

  switch (verticalName) {
    case 'homes': {
      features = location ? buildFeaturesHomes(location, verticalProperties) : null;
      break;
    }
    case 'cars':
      features = buildFeaturesCars(verticalProperties);
      break;
    case 'jobs':
      features = buildFeaturesJobs(verticalProperties);
      break;
    case 'products':
      features = buildFeaturesProducts(verticalProperties);
      break;
    default:
      features = null;
  }

  return features;
};

export const buildRedirectParams = (trovit, userId) => ({
  userCampaignIds: trovit.userCampaignIds && trovit.userCampaignIds,
  'abTest[id]': get(trovit, ['abTest', 'id']),
  'abTest[option]': get(trovit, ['abTest', 'option']),
  'abTest[platform]': get(trovit, ['abTest', 'platform']),
  'redirect[userId]': userId,
  'redirect[cookieId]': trovit.installationId,
  'redirect[trackingCode]': get(trovit, ['trackingCodes', `${trovit.origin}`]),
  'redirect[pageViewId]': trovit.pageviewId,
  'redirect[suggester]': null,
});

export const buildQueryParamsForRelatedAds = ({
  verticalName,
  countryCode,
  ad,
  what,
  where,
  trovit,
  userId,
}) => {
  const features = buildFeatures({
    verticalName,
    verticalProperties: {
      ...ad.verticalProperties,
      ...{
        location: ad.location,
        what,
        where,
      },
    },
  });

  return {
    adId: ad.id,
    title: ad.title,
    price: get(ad, ['verticalProperties', 'price', 'value']),
    ...features,
    countryCode,
    device: 'mobile',
    clientId: 'pwa-mobile',
    originId: trovit.origin,
    ...buildRedirectParams(trovit, userId),
  };
};

export const buildMetricsData = (verticalName, countryCode, apiName, apiResource) => ({
  verticalName,
  countryCode,
  apiName,
  apiResource,
});



// WEBPACK FOOTER //
// ./app/sdk/common/utils.js